<!-- AppLinkCliente.svelte -->
<script>
    import {onMount} from 'svelte'
    import Cookie from 'js-cookie'
	import {USER} from './store.js'
	import ClienteCAM from './cliente/cliente-cam.svelte'
    import Pagos from './pagos/pagos-cliente.svelte'
    import {HOST,API,http_headers} from './global.js'

    export let cliente = 0
    export let codigo = ''
    export const pagoid = ''

    let acceso = false
    let loading = false
    let mensaje = ''
    let ds = {}


    async function verificar_acceso(){

        let usr = Cookie.get('gsc-user2') || '{ "username":"" , "fullname":"" , "aclist":"" }'
        // si existe y es valiada la cookie, cargo USER e ingreso
        if(usr.username){
            USER.set(JSON.parse(usr))
            acceso=true
            return
        }
        //si no

        let cliente_info = {
            cliente : parseInt(cliente) ,
            codigo : codigo.trim()
        }

        if (cliente_info.cliente===0 || cliente_info.codigo==='') {
            acceso=false
            mensaje = "Acceso no autorizado. (code:#1)"
            return
        }

        loading = true
		let rs = await fetch(`${API}/login-cliente`,{
			method : 'POST',
			headers: http_headers,
	        body: JSON.stringify(cliente_info)
		})
		ds = await rs.json() || []
		loading = false

		if(ds.success){
			let vigencia = new Date(new Date().getTime() + 14 * 60 * 60 * 1000)
			Cookie.set(ds.token_cookie, ds.token_value, { expires:vigencia , path: HOST })
			Cookie.set(ds.user_cookie, JSON.stringify(ds.user_value), { expires:vigencia , path: HOST })
			let usr = Cookie.get('gsc-user2') || '{"username":"", "fullname":"", "aclist":""}'
			USER.set(JSON.parse(usr))
            acceso=true
		}else{
			mensaje = ds.err
		}
    }

    onMount( async() => {
        await verificar_acceso()
    })

</script>

<div class="header sticky-top text-white p-1">
    <h5 class="fw-bold"><img src="img/logo.png" alt="" width="40">  Rincon Club</h5></div>
<div class="container-fluid">
    {#if acceso}

        <!-- <pre>{JSON.stringify($USER,null,2)}</pre> -->

            <div class="alert alert-primary mt-3" role="alert">
                <h5 class="fw-bold">CLIENTE : {cliente}&nbsp;&nbsp;&nbsp;{$USER.apellido.trim()+' '+$USER.nombre}</h5>
            </div>

            <ClienteCAM data="{{info : { IdCliente:cliente, IdEjecutivo:''}}}" />

            <Pagos data={{info:{IdCliente:cliente}}}/>

            
            <br>
            <div class="container mt-4 pb-4">
                <hr>
                {#if $USER.nomeje }
                     <p class="text-center"><small>Su ejecutivo de cuenta es {$USER.nomeje} {$USER.apeeje},
                         por cualquier consulta puede contactarlo a su email :
                         <i>{$USER.emaileje}</i> o telefonicamente a (011) {$USER.telefono}.
                     </small>
                     </p>
                {/if}
                <div class="text-success text-center mt-4">
                    <div>&reg; <small>Rinc&oacute;n Club</small></div>
                    <div>&#9993; <small><i>info@rinconclub.com.ar</i></small></div>
                    <div>&phone; <small>0810 777-7768 (Rincon)</small></div>
                </div>
            </div>


{:else if !loading}
    <div class="alert alert-danger m-4" role="alert">
        No puede ingresar, los datos proporcionados no son validos, por favor verifiquelos.
    </div>
{:else}
    <div class="spinner-border mt-4 text-center" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
{/if}
</div>

<style>
    .header{
        background-color:#002a53;
    }
</style>
